import { MushroomIcon } from './MushroomIcon';

/**
 * author: Chris Thron
 * id FCA4F099-5FCB-43DE-8166-2CE30508C1EC
 * name mushroom
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/mushroom.svg
 * tags
 * - Nature 
 * - Food / Drink 
 * - Agriculture 
 */
export const FungusIcon = MushroomIcon;
export default FungusIcon